export default __webpack_public_path__ + "static/13-cdf5de5ff46286ae47c30ff6ad2e998b.webp";